/**
 * GDPR cookie consent storage and helpers.
 * Consent is stored in localStorage (key: vto_gdpr_consent).
 * Essential storage (cookies, localStorage, IndexedDB for VTO) always runs;
 * optional analytics is gated by consent.
 */

const CONSENT_KEY = 'vto_gdpr_consent';

const DEFAULT_CONSENT = {
  essential: true,
  analytics: false,
  timestamp: null,
};

/**
 * @returns {{ essential: boolean, analytics: boolean, timestamp: number | null }}
 */
export function getConsent() {
  try {
    const raw = typeof window !== 'undefined' ? localStorage.getItem(CONSENT_KEY) : null;
    if (!raw) return { ...DEFAULT_CONSENT };
    const parsed = JSON.parse(raw);
    return {
      essential: parsed.essential !== false,
      analytics: Boolean(parsed.analytics),
      timestamp: typeof parsed.timestamp === 'number' ? parsed.timestamp : null,
    };
  } catch {
    return { ...DEFAULT_CONSENT };
  }
}

/**
 * @param {{ essential?: boolean, analytics?: boolean }} opts
 */
export function setConsent(opts) {
  const prev = getConsent();
  const next = {
    essential: opts.essential !== false,
    analytics: Boolean(opts.analytics),
    timestamp: Date.now(),
  };
  try {
    localStorage.setItem(CONSENT_KEY, JSON.stringify(next));
    if (typeof window !== 'undefined' && (prev.analytics !== next.analytics || !prev.timestamp)) {
      window.dispatchEvent(new CustomEvent('gdpr-consent-updated', { detail: next }));
    }
  } catch {
    /* ignore */
  }
  return next;
}

/** Has the user made a consent choice (dismissed banner)? */
export function hasConsentChoice() {
  const c = getConsent();
  return c.timestamp != null;
}

/** Allow analytics (only meaningful when hasConsentChoice)? */
export function analyticsAllowed() {
  const c = getConsent();
  return c.analytics === true;
}
